module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-E.a62a1f54.png";